<div class="container-promo">
  <div class="row">
    <div class="qrcode">
      <img [src]="imgQrCode" alt="">
    </div>
    <div class="logo">
      <img class="rounded mx-auto d-block" src="assets/img/logo_only_tv_package_page_app4.png">
    </div>
  </div>
  <div class="row">
    <p>{{ message1 }}</p>
    <p>{{ message2 }}</p>
    <h1>{{ qrcode }}</h1>
  </div>
</div>
